import React, { createContext } from 'react';
import { useNavigate } from 'react-router-dom';

const NavigationContext = createContext<(path: string) => void>(() => {});

let navigateHandler: (path: string) => void = () => {};

export const setNavigateHandler = (fn: (path: string) => void) => {
  navigateHandler = fn;
};

export const redirectTo = (path: string) => {
  navigateHandler(path);
};

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigate = useNavigate();

  React.useEffect(() => {
    setNavigateHandler(navigate);
  }, [navigate]);

  return (
    <NavigationContext.Provider value={navigate}>
      {children}
    </NavigationContext.Provider>
  );
};
